<template>
  <div class="box">
    <!-- AI双师进入页 -->
    <!-- <iframe src="https://assfe.tianyuyun.com/jqueryswiperlbt/index.html" width="100%" height="100%" frameborder="0"></iframe> -->
  </div>
</template>

<script>
import axios from "axios";
import util from "@/utils/util.js";
import {
  getSixUser,
  getSevenUser,
  getRoleinfo,
  getRoleinfo1,
} from "@/api/user/user.js";
export default {
  data() {
    return {
      schoolName: "",
    };
  },
  created() {
    this.load();
  },
  methods: {
    async load() {
      let { platformCode, ticket } = this.$route.query;
      if (!ticket) {
        let urlObj = util.getRequest();
        ticket = urlObj.ticket;
        platformCode = urlObj.platformCode;
      }
      console.log("AI教育获取url参数:", ticket, platformCode);
      sessionStorage.loginPlatformCode = platformCode;
      sessionStorage.platformVersion = "7";
      // console.log("正式环境--获取ticket:" + ticket);
      let info = {};
      if (sessionStorage.platformVersion === "6") {
        let { result, userinfo = {} } = await getSixUser({ ticket });
        info = userinfo;

        console.log(
          "🚀 ~ file: Entry.vue ~ line 49 ~ initUser ~ userinfo",
          result,
          userinfo
        );
      } else {
        let { code, result = {} } = await getSevenUser({ ticket });
        console.log(
          "🚀 ~ file: Entry.vue ~ line 52 ~ initUser ~ result",
          code,
          result
        );
        console.log("AI教育--获取用户信息11111", result);
        info = result;
      }
      this.schoolName = info.last_top_org_name;
      this.addAccessRecords(info);
      this.windowOPen()
    },
    // 调取记录访问信息接口
   async addAccessRecords(info) {
      let accessClasses = [];
      if (info.user_org.length > 0) {
        info.user_org.forEach((it) => {
          let obj = {
            classId: it.org_id || "",
            className: it.org_name || "",
          };
          accessClasses.push(obj);
        });
      }
      let params = {
        platformCode: info.platform_code || info.platformCode,
        personId: info.user_id || info.personId ,
        accessTarget: "1",
        name: info.name || "",
        orgaId: info.last_top_org_id || "",
        orgaName: info.last_top_org_name || "",
        areaCode: info.area_code || "",
        cityCode: info.city_code || "",
        provinceCode: info.province_code || "",
        accessClasses: accessClasses,
      };
     const { data }  = await axios.post(
        "https://ms-support.huijiaoyun.com/api/accessrecord/add",
        params
      );
      console.log("调取记录访问信息接口参数", params,data);
    },
    // 获取信息跳转到AI双师五育素养课
    windowOPen() {
      window.open(
        "https://assfe.tianyuyun.com/jqueryswiperlbt/index.html?partnerTrackingClassroom=" +
          this.schoolName,
        "_self"
      );
    },
  },
};
</script>

<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
}
.box {
  width: 100%;
  height: 100%;
}
</style>
